/** localStorage key for showing the rotating trader psychology tip banner */
export function getTraderPsychologyTipStorageKey(email) {
  if (email && String(email).trim()) {
    return `trader_psychology_tip_enabled_${String(email).trim()}`;
  }
  return 'trader_psychology_tip_enabled_anon';
}

export function readTraderPsychologyTipEnabled(email) {
  if (typeof localStorage === 'undefined') return true;
  const key = getTraderPsychologyTipStorageKey(email);
  const v = localStorage.getItem(key);
  if (v === null) return true;
  return v === 'true';
}

export function writeTraderPsychologyTipEnabled(email, enabled) {
  if (typeof localStorage === 'undefined') return;
  const key = getTraderPsychologyTipStorageKey(email);
  localStorage.setItem(key, String(Boolean(enabled)));
  window.dispatchEvent(new CustomEvent('risklo-trader-psychology-tip-preference'));
}
